import { render, staticRenderFns } from "./FrequencyDetailsModal.vue?vue&type=template&id=17e90d4a&scoped=true&"
import script from "./FrequencyDetailsModal.vue?vue&type=script&lang=js&"
export * from "./FrequencyDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyDetailsModal.vue?vue&type=style&index=0&id=17e90d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e90d4a",
  null
  
)

export default component.exports